import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isPending: false,
  referralCode: [],
};

const referralCode = createSlice({
  name: "referralCode",
  initialState,
  reducers: {
    isPending: (state) => {
      state.isPending = true;
    },
    fetchReferralSuccess: (state, { payload }) => {
      state.isPending = false;
      state.referralCode = payload;
    },

    fetchReferralFailure: (state, { payload }) => {
      state.isPending = false;
    },
  },
});

const { reducer, actions } = referralCode;

export const { isPending, fetchReferralSuccess, fetchReferralFailure } = actions;

export default reducer;
